export const UserTypes = {
    GET_PROFILE: 'GET_PROFILE',
    GET_PROFILE_ERROR: 'GET_PROFILE_ERROR',
    UPDATE_PROFILE: 'UPDATE_PROFILE',
    UPDATE_PROFILE_ERROR: 'UPDATE_PROFILE_ERROR'
}